import React from 'react';
import { A } from '@contently/toolkit';
import Recommendation from './recommendation';
import { recShape } from './recommendation_mapper';
import LinkedStory from './linked_story';

const ContentRefreshRecommendation = ({ rec }) => {
  const headline = 'Keep your highest performing content fresh';
  const helpDeskHref =
    'https://contently-support.zendesk.com/hc/en-us/articles/21627483905810-Optimizing-existing-content-for-organic-search-visibility';

  const helpDeskLink = (
    <A href={helpDeskHref} title="Optimizing existing content for organic search visibility">
      updating
    </A>
  );

  return (
    <Recommendation headline={headline} rec={rec}>
      <LinkedStory id={rec.id} href={rec.primaryItem.link} title={rec.primaryItem.title} />
      {' has above-average '}
      {rec.metric}
      {' and was created more than six months ago. Consider '}
      {helpDeskLink}
      {' this story to keep it fresh and increase organic search visibility.'}
    </Recommendation>
  );
};

export default ContentRefreshRecommendation;

ContentRefreshRecommendation.propTypes = {
  rec: recShape.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/content_refresh_recommendation.jsx